import { isSessionSelectable } from 'common-data-handling';
import { useEventSchedule } from './useEventSchedule';

/**
 * Selectable sessions for an event.
 * @param {number} eventId - The ID of the event to fetch sessions for.
 * @returns {array} An array of sessions that are selectable for the user.
 */
export function useSelectableSessions(eventId) {
    return useEventSchedule(eventId, {
        filter: isSessionSelectable,
    });
}
